import './Projects.css'
import { useEffect, useState } from 'react';
import defaultProjectImg from './resources/defaultProjectImg.jpg'
import { getProjects } from '../services/data';

import Carousel from './Carousel';

export default function Projects({ isVisible }) {
  const [projects, setProjects] = useState([]);

  useEffect(() => {
    const fetchProjects = async () => {
      try {
        const result = await getProjects();
        setProjects(result);
      } catch (error) {
        console.log('Error fetching projects:', error);
      }
    };
    fetchProjects();
  }, []);

  const renderProjectCard = (project) => (
    <div className='project-card'>
      <div className='project-image-container'>
        <img
          src={project.image ? project.image : defaultProjectImg}
          alt={project.title}
        />
        <div className='project-overlay'></div>
      </div>
      <div className='project-content'>
        <h3 className='project-title'>{project.title}</h3>
        <div className='project-description'>{project.description}</div>
        {project.techStacks && (
          <div className='tech-stack-container'>
            {project.techStacks.split(',').map((tech, techIndex) => (
              <span key={techIndex} className='tech-badge'>
                {tech.trim()}
              </span>
            ))}
          </div>
        )}
        <div className='project-links'>
          {project.github && (
            <a
              href={project.github}
              target="_blank"
              rel="noopener noreferrer"
              className='project-link github-link'
              onClick={(e) => e.stopPropagation()}
            >
              <svg width="20" height="20" viewBox="0 0 24 24" fill="currentColor">
                <path d="M12 0c-6.626 0-12 5.373-12 12 0 5.302 3.438 9.8 8.207 11.387.599.111.793-.261.793-.577v-2.234c-3.338.726-4.033-1.416-4.033-1.416-.546-1.387-1.333-1.756-1.333-1.756-1.089-.745.083-.729.083-.729 1.205.084 1.839 1.237 1.839 1.237 1.07 1.834 2.807 1.304 3.492.997.107-.775.418-1.305.762-1.604-2.665-.305-5.467-1.334-5.467-5.931 0-1.311.469-2.381 1.236-3.221-.124-.303-.535-1.524.117-3.176 0 0 1.008-.322 3.301 1.23.957-.266 1.983-.399 3.003-.404 1.02.005 2.047.138 3.006.404 2.291-1.552 3.297-1.23 3.297-1.23.653 1.653.242 2.874.118 3.176.77.84 1.235 1.911 1.235 3.221 0 4.609-2.807 5.624-5.479 5.921.43.372.823 1.102.823 2.222v3.293c0 .319.192.694.801.576 4.765-1.589 8.199-6.086 8.199-11.386 0-6.627-5.373-12-12-12z" />
              </svg>
              GitHub
            </a>
          )}
          {project.liveDemo && (
            <a
              href={project.liveDemo}
              target="_blank"
              rel="noopener noreferrer"
              className='project-link demo-link'
              onClick={(e) => e.stopPropagation()}
            >
              <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                <path d="M18 13v6a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h6"></path>
                <polyline points="15 3 21 3 21 9"></polyline>
                <line x1="10" y1="14" x2="21" y2="3"></line>
              </svg>
              Live Demo
            </a>
          )}
        </div>
      </div>
    </div>
  );

  return (
    <Carousel 
      items={projects} 
      renderCard={renderProjectCard} 
      isVisible={isVisible} 
    />
  );
}